import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Bookmark } from "lucide-react";
import { toast } from "sonner";

export const SaveJobButton = ({ jobId, saved, onToggle, className = "" }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [localSaved, setLocalSaved] = useState(saved);
  const isSaved = saved !== undefined ? saved : localSaved;

  const click = async (e) => {
    e.stopPropagation();
    if (!user) return navigate("/login");
    if (user.role !== "applicant") return toast.error("Only applicants can save jobs.");
    setBusy(true);
    try {
      const { data } = await api.post("/saved-jobs", { job_id: jobId });
      setLocalSaved(data.saved);
      onToggle?.(jobId, data.saved);
      toast.success(data.saved ? "Saved" : "Removed from saved");
    } catch {
      toast.error("Could not update");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={click}
      disabled={busy}
      data-testid={`save-job-${jobId}`}
      aria-label={isSaved ? "Unsave job" : "Save job"}
      className={`inline-flex items-center justify-center h-8 w-8 rounded-lg border transition-colors ${isSaved ? "bg-amber-100 border-amber-300 text-amber-600" : "bg-white border-slate-200 text-slate-400 hover:text-amber-600 hover:border-amber-300"} ${className}`}
    >
      <Bookmark className="h-4 w-4" fill={isSaved ? "currentColor" : "none"} />
    </button>
  );
};
